<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="menuInformationCenterFull"
          :redirect_name="redirect_name"
          :hide_back="inBottomNavbar"
        />
      </v-col>
    </v-row>

    <v-row class="mt-3 mb-1">
      <v-col class="d-flex justify-end py-0 px-5" cols="12">
        <v-btn
          class="text-none"
          rounded
          small
          :color="site.color"
          @click="dialogFloatPanelFilter = true"
        >
          <p
            class="d-flex align-center ma-1 text-end text-subtitle-2"
            :style="{
              color: setColorFilter(),
            }"
          >
            <v-icon :color="setColorFilter()">mdi-sort-variant</v-icon>
            {{ $t("textFilter") }}
          </p>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="px-2 mt-2" style="padding-bottom: 80px">
      <v-col
        v-for="(item, index) in listData"
        :key="index"
        cols="12"
        class="py-1 mt-1"
      >
        <v-sheet rounded>
          <v-card
            elevation="2"
            rounded="lg"
            @click="onClickCard(item)"
            :style="{
              backgroundColor: setBackgoundBox(item),
            }"
          >
            <v-card-title class="py-2 px-2">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <div class="d-flex" style="gap: 14px; z-index: 1">
                      <div class="d-flex flex-column" style="width: 100%">
                        <div
                          class="d-flex align-center justify-space-between"
                          style="gap: 4px"
                        >
                          <p
                            class="description-label title-card text-start mb-0 pb-0 text-subtitle-1 font-weight-bold"
                            style="max-height: 42px"
                          >
                            {{ item.title }}
                          </p>
                        </div>
                        <p
                          class="description-label-1 title-card text-start mb-0 pb-0 text-subtitle-2 grey--text text--darken-1 pt-1"
                        >
                          {{ item.sub_title }}
                        </p>
                        <p
                          class="description-label-1 title-card text-start mb-0 pb-0 grey--text text--darken-1 pt-1"
                          style="font-size: 12px; word-break: normal"
                          v-html="formatHtmlDetail(item.detail)"
                        ></p>
                        <div class="d-flex align-center mt-2">
                          <v-chip v-if="item.report_type_name" small>{{
                            item.report_type_name
                          }}</v-chip>
                          <v-chip
                            v-if="item.is_update"
                            color="#FFF3E0"
                            x-small
                            dark
                            class="px-2 py-3 mr-0 ml-auto"
                            style="width: fit-content"
                            ><v-icon x-small class="mr-1" color="#E65100"
                              >mdi-sync</v-icon
                            >
                            <div style="color: #e65100">
                              {{ $t("textUpdated") }}
                            </div>
                          </v-chip>
                        </div>
                      </div>
                    </div>
                    <v-divider class="my-2"></v-divider>

                    <!-- ========== ========== Bottom ========== ========== -->
                    <div
                      class="d-flex"
                      style="width: 100%; height: 28px; gap: 4px"
                    >
                      <!-- Created At -->
                      <div
                        class="d-flex align-center pa-2"
                        style="
                          gap: 4px;
                          border: 1px solid #e0e0e0;
                          border-radius: 4px;
                        "
                      >
                        <v-icon small color="#757575">mdi-calendar</v-icon>
                        <div style="color: #757575; font-size: 14px">
                          {{ item.created_at | formatDate }}
                        </div>
                      </div>

                      <!-- Attach File -->
                      <div
                        v-if="item.report_files && item.report_files.length > 0"
                        class="d-flex align-center pa-2 pl-1"
                        style="
                          gap: 2px;
                          border: 1px solid #e0e0e0;
                          border-radius: 4px;
                        "
                      >
                        <v-icon
                          small
                          color="#757575"
                          style="transform: rotate(-90deg)"
                          >mdi-attachment</v-icon
                        >
                        <div style="color: #757575; font-size: 14px">
                          {{ item.report_files.length }}
                        </div>
                      </div>

                      <!-- Comment -->
                      <div
                        class="d-flex align-center pa-2"
                        style="
                          gap: 4px;
                          border: 1px solid #e0e0e0;
                          border-radius: 4px;
                        "
                      >
                        <v-badge
                          overlap
                          color="red"
                          dot
                          :value="item.is_unread_comment"
                        >
                          <v-icon small color="#757575"
                            >mdi-comment-outline</v-icon
                          >
                        </v-badge>

                        <div
                          v-if="item.total_comment > 0"
                          style="color: #757575; font-size: 14px"
                        >
                          {{ item.total_comment }}
                        </div>
                      </div>

                      <!-- Favorite -->
                      <div
                        class="d-flex align-center pa-2 ml-auto mr-0"
                        style="
                          gap: 4px;
                          border: 1px solid #e0e0e0;
                          border-radius: 4px;
                          cursor: pointer;
                        "
                        @click="onClickFavorite($event, index)"
                      >
                        <v-icon v-if="item.is_favorite" small color="#F9A825"
                          >mdi-star</v-icon
                        >
                        <v-icon v-else small color="#F9A825"
                          >mdi-star-outline</v-icon
                        >
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!listData.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <FloatPanelFilter
      :dialog="dialogFloatPanelFilter"
      :forCreatedBy="forCreatedBy"
      @onClose="dialogFloatPanelFilter = false"
      @onSubmit="onClickSubmitFilter"
    />

    <v-snackbar v-model="modalFavorite.alert" :color="modalFavorite.color">
      <v-icon>mdi-check-circle-outline</v-icon>
      {{ $t(modalFavorite.text) }}
    </v-snackbar>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import moment from "moment";
import FloatPanelFilter from "../../../components/reportAdminUser/float-panel-filter.vue";
import { formatHtmlDetailDefault, getFontColorBasedOnBg } from "../../../config/general-function";
import FloatPanel from "../../../components/floatPanel.vue";
import {
  firebaseListener,
  firebaseStopListener,
} from "../../../config/firebaseMessage.js";

export default {
  inject: ["isAppLoading"],
  emits: ["onClick"],
  components: {
    InfiniteLoading,
    FloatPanelFilter,
    HeaderTextBg,
    FloatPanel,
  },

  data() {
    return {
      next_page_url: "",
      infiniteId: +new Date(),
      listData: [],
      dialogFloatPanelFilter: false,
      dialogFloatPanel: false,

      filterBy: "",
      filterValue: "",
      sortBy: "",
      orderBy: "",

      modalFavorite: {
        alert: false,
        text: "",
        color: "",
      },

      forCreatedBy: "admin",

      redirect_name: "main",

      listFirebaseTopic: [],
    };
  },
  created() {},
  beforeDestroy() {
    for (let item of this.listFirebaseTopic) {
      firebaseStopListener(item);
    }
  },
  methods: {
    setBackgoundBox(param) {
      let _color = "#ffffff";
      if (param.is_unread) {
        _color = "#E1F5FE";
      }
      return _color;
    },
    setColorFilter() {
      let _color = getFontColorBasedOnBg(this.site.color, "bw");
      return _color;
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },

    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get(`/report-admin/getListReportAdmin`, {
        params: {
          create_by: this.forCreatedBy,
          page: this.next_page_url,
          filterBy: this.filterBy,
          filterValue: this.filterValue,
          sortBy: this.sortBy,
          orderBy: this.orderBy,
        },
      })
        .then(({ data }) => {
          if (Array.isArray(data?.data?.data)) {
            let has_more = data.data.has_more;
            this.listData = this.listData.concat(data.data.data);
            for (let item of this.listData) {
              const topic = `report/${item.id}/report_comment`;
              if (!this.listFirebaseTopic.includes(topic)) {
                firebaseListener(topic, (data) => {
                  this.realtimeCheckUpdate(topic, data);
                });
                this.listFirebaseTopic.push(topic);
              }
            }
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    async getListReportAdminByReportId(report_id) {
      let dataReturn = null;
      try {
        const response = await Axios.get(`/report-admin/getListReportAdmin`, {
          params: {
            create_by: this.forCreatedBy,
            report_id: report_id,
          },
        });
        const dataResponse = response.data;
        if (
          Array.isArray(dataResponse?.data?.data) &&
          dataResponse?.data?.data?.length
        ) {
          const list = dataResponse.data.data;
          if (list.length > 0) {
            dataReturn = list[0];
          }
        }
      } catch (err) {
        console.log("err getListReportAdminByReportId", err);
      }
      return dataReturn;
    },
    async realtimeCheckUpdate(topic, data) {
      const _data = await this.getListReportAdminByReportId(data?.report_id);
      if (_data) {
        const index = this.listData.findIndex((x) => x.id === _data.id);
        if (index >= 0) {
          this.$set(this.listData, index, { ..._data });
        }
      }
    },

    onClickCard(param) {
      this.$router.push({
        name: `information-center-detail`,
        params: { id: param.id },
      });
    },
    async onClickFavorite(event, index) {
      event.stopPropagation();
      let list = [...this.listData];
      const is_favorite = !list[index].is_favorite;
      try {
        let response = await Axios.post(`/report-admin/favoriteReportAdmin/`, {
          report_id: list[index].id,
          is_favorite: is_favorite,
        });
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          list[index].is_favorite = is_favorite;
          this.listData = [...list];
          this.modalFavorite.text = is_favorite
            ? "addFavorite"
            : "removeFavorite";
          this.modalFavorite.color = is_favorite ? "green" : "#BDBDBD";
          this.modalFavorite.alert = true;
        } else {
          this.$swal.fire({
            icon: "error",
            title: dataResponse.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (err) {
        console.log("favoriteReportAdmin", err);
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    onClickSubmitFilter(param) {
      this.filterBy = param.filterBy;
      this.filterValue = param.filterValue;
      this.sortBy = param.sortBy;
      this.orderBy = param.orderBy;
      this.next_page_url = "";
      this.infiniteId += 1;
      this.listData = [];
      this.dialogFloatPanelFilter = false;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  watch: {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.description-label-1 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.title-card {
  line-height: 1.3;
}

::v-deep .v-badge__wrapper {
  left: 3px;
  top: 1px;
}
::v-deep .v-badge__badge {
  width: 6px;
  height: 6px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}
</style>
